/* eslint-disable eqeqeq */
import FormFw from "../../../framework/form/FormFw";
import GridFw from "../../../framework/grid/GridFw";
import BarButtonFw, { BUTTON_DEFAULT } from "../../../framework/bar-button/BarButtonFw";
import { MessageUtil } from "../../../util/MessageUtil";

export const DetalleMuestreoModal = (props) => {
  const { api, gridsConfig = [], history, cambiarTabPanel, data } = props;

  const barButtonFooterdatos_servicio = {
    fields: [
      {
        ...BUTTON_DEFAULT.RETURN,
        label: "Retornar Inicio",
        onClick: () => {
          const pathBack = history?.location?.state?.from 
            || `/solicitudes-asignadas/solicitudes-asignadas/${data.id_ss}`;
          history.push(pathBack);
        },
      },
      {
        ...BUTTON_DEFAULT.SAVE,
        label: "Guardar",
        onClick: () => {
          gridsConfig?.forEach((g) => {
            const grid = api.getComponent(g.name);
            if (g.readonly !== true) {
              if (grid?.save) {
                grid?.save();
              } else if (grid?.update) {
                grid?.update();
              }
            }
          });

          MessageUtil("success", "Se actualizó correctamente.");
        },
      },
      {
        ...BUTTON_DEFAULT.NEXT,
        label: "Continuar",
        onClick: () => {
          cambiarTabPanel("5", 0);

          gridsConfig.forEach((g) => {
            const grid = api.getComponent(g.name);
            if (g.readOnly !== true) {
              if (grid?.save) {
                grid?.save();
              } else if (grid?.update) {
                grid?.update();
              }
            }
          });

          MessageUtil("success", "Se actualizó correctamente.");
        },
      },
    ],
  };

  return (
    <>
      {gridsConfig && gridsConfig?.map((grid) => {
        if (grid.type === 'grid') {
          return (
            <GridFw
              key={grid.name}
              name={grid.name}
              getParentApi={api.getApi}
              config={grid.config}
            />
          )
        } else if (grid.type === 'form') {
          return (
            <FormFw
              key={grid.name}
              name={grid.name}
              getParentApi={api.getApi}
              config={grid.config}
            />
          )
        } else {
          return <></>
        }
      })}

      <BarButtonFw
        name="barFooter"
        getParentApi={api.getApi}
        config={barButtonFooterdatos_servicio}
      />
    </>
  );
};